export const DEFAULT_SHORTCUT_CONGIF = {
  ignore_preventSc: false, // 无视preventSc阻挡
  km_list: false, // 字段value是，不定项数组，包含多个快捷键
  need_config: [], // 开启此快捷键依赖的 setting_data 中的变量名数组, 比如 按键麦快捷键 需要setting_data中的audio_press_mode == true(是否开启按键麦选项)
  deliver_key_up: false // 需要上报键盘抬起
}